/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_InstructorInputs */

const en_field_instructor = /** @type {(inputs: Field_InstructorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instructor`)
};

const es_field_instructor = /** @type {(inputs: Field_InstructorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instructor`)
};

const fr_field_instructor = /** @type {(inputs: Field_InstructorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instructeur`)
};

const de_field_instructor = /** @type {(inputs: Field_InstructorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leiter / Instruktor`)
};

const ja_field_instructor = /** @type {(inputs: Field_InstructorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`インストラクター`)
};

const zh_field_instructor = /** @type {(inputs: Field_InstructorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`讲师/教练`)
};

const ar_field_instructor = /** @type {(inputs: Field_InstructorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المدرب`)
};

const id_field_instructor = /** @type {(inputs: Field_InstructorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instruktur`)
};

const it_field_instructor = /** @type {(inputs: Field_InstructorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Istruttore`)
};

const ru_field_instructor = /** @type {(inputs: Field_InstructorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Инструктор/Преподаватель`)
};

const pt_field_instructor = /** @type {(inputs: Field_InstructorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instrutor`)
};

const ko_field_instructor = /** @type {(inputs: Field_InstructorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`강사`)
};

/**
* | output |
* | --- |
* | "Instructor" |
*
* @param {Field_InstructorInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_instructor = /** @type {((inputs?: Field_InstructorInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_InstructorInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_instructor(inputs)
	if (locale === "es") return es_field_instructor(inputs)
	if (locale === "fr") return fr_field_instructor(inputs)
	if (locale === "de") return de_field_instructor(inputs)
	if (locale === "ja") return ja_field_instructor(inputs)
	if (locale === "zh") return zh_field_instructor(inputs)
	if (locale === "ar") return ar_field_instructor(inputs)
	if (locale === "id") return id_field_instructor(inputs)
	if (locale === "it") return it_field_instructor(inputs)
	if (locale === "ru") return ru_field_instructor(inputs)
	if (locale === "pt") return pt_field_instructor(inputs)
	return ko_field_instructor(inputs)
});